<div class="root-container">
  <div class="content scrollbars" #content>
    <public-header [content]="content" />

    <main class="main-content">
      <router-outlet />
    </main>

    <public-footer />


  </div>
</div>

